webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./assets/check-white.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/spinner.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4wIiB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cnc8Zz48cGF0aCBkPSJNNjQgMTI4QTY0IDY0IDAgMCAxIDE4LjM0IDE5LjE2TDIxLjE2IDIyYTYwIDYwIDAgMSAwIDUyLjgtMTcuMTdsLjYyLTMuOTVBNjQgNjQgMCAwIDEgNjQgMTI4eiIgZmlsbD0iI2ZmZmZmZiIgZmlsbC1vcGFjaXR5PSIxIi8+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgNjQgNjQiIHRvPSIzNjAgNjQgNjQiIGR1cj0iMTgwMG1zIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPjwvZz48L3N2Zz4="

/***/ }),

/***/ "./node_modules/create-react-class/factory.js":
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("./node_modules/object-assign/index.js");
	
	var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ "./node_modules/create-react-class/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	var factory = __webpack_require__("./node_modules/create-react-class/factory.js");
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ "./node_modules/react-timeout/src/reactTimeout.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createReactClass = __webpack_require__("./node_modules/create-react-class/index.js")
	var objectAssign = __webpack_require__("./node_modules/object-assign/index.js")
	
	var createReactTimeout = function (React) {
	  var GLOBAL = typeof window === 'undefined' ? global : window
	
	  var setter = function (_setter, _clearer, array) {
	    return function (callback, delta) {
	      var id = _setter(function () {
	        _clearer.call(this, id)
	        callback.apply(this, arguments)
	      }.bind(this), delta)
	
	      if (!this[array]) {
	        this[array] = [id]
	      } else {
	        this[array].push(id)
	      }
	      return id
	    }
	  }
	
	  var clearer = function (_clearer, array) {
	    return function (id) {
	      if (this[array]) {
	        var index = this[array].indexOf(id)
	        if (index !== -1) {
	          this[array].splice(index, 1)
	        }
	      }
	      _clearer(id)
	    }
	  }
	
	  var _timeouts = '_ReactTimeout_timeouts'
	  var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts)
	  var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts)
	
	  var _intervals = '_ReactTimeout_intervals'
	  var _clearInterval = clearer(GLOBAL.clearInterval, _intervals)
	  var _setInterval = setter(GLOBAL.setInterval, function () {}, _intervals)
	
	  var _immediates = '_ReactTimeout_immediates'
	  var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates)
	  var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates)
	
	  var _rafs = '_ReactTimeout_rafs'
	  var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs)
	  var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs)
	
	  var cloneArray = function (a) {
	    return (!a || typeof a.slice !== 'function') ? [] : a.slice(0)
	  }
	
	  var ReactTimeout = function (SourceComponent) {
	    return createReactClass({
	      displayName: 'ReactTimeout',
	
	      setTimeout: _setTimeout,
	      clearTimeout: _clearTimeout,
	
	      setInterval: _setInterval,
	      clearInterval: _clearInterval,
	
	      setImmediate: _setImmediate,
	      clearImmediate: _clearImmediate,
	
	      requestAnimationFrame: _requestAnimationFrame,
	      cancelAnimationFrame: _cancelAnimationFrame,
	
	      componentWillUnmount: function () {
	        cloneArray(this[_timeouts]).forEach(this.clearTimeout)
	        cloneArray(this[_intervals]).forEach(this.clearInterval)
	        cloneArray(this[_immediates]).forEach(this.clearImmediate)
	        cloneArray(this[_rafs]).forEach(this.cancelAnimationFrame)
	      },
	
	      render: function () {
	        return React.createElement(
	          SourceComponent,
	          objectAssign(
	            {},
	            this.props,
	            {
	              setTimeout: this.setTimeout,
	              clearTimeout: this.clearTimeout,
	
	              setInterval: this.setInterval,
	              clearInterval: this.clearInterval,
	
	              setImmediate: this.setImmediate,
	              clearImmediate: this.clearImmediate,
	
	              requestAnimationFrame: this.requestAnimationFrame,
	              cancelAnimationFrame: this.cancelAnimationFrame
	            }))
	      }
	    })
	  }
	
	  return ReactTimeout
	}
	
	module.exports = createReactTimeout
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/react-timeout/src/web.js":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js")
	var createReactTimeout = __webpack_require__("./node_modules/react-timeout/src/reactTimeout.js")
	
	module.exports = createReactTimeout(React)


/***/ }),

/***/ "./src/components/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 22rem;\n  background-color: ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 22rem;\n  background-color: ", ";\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    padding: 3rem 2rem;\n  "], ["\n    padding: 3rem 2rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    padding: 4rem 2rem;\n  "], ["\n    padding: 4rem 2rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n  color: #999;\n  font-size: 0.65rem;\n  line-height: 1.4;\n  padding: 1.5rem 2rem 1.25rem;\n  max-width: 48rem;\n"], ["\n  width: 100%;\n  text-align: center;\n  color: #999;\n  font-size: 0.65rem;\n  line-height: 1.4;\n  padding: 1.5rem 2rem 1.25rem;\n  max-width: 48rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n  max-width: 72rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  flex: 1;\n  width: 100%;\n  max-width: 72rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0.3125rem;\n  padding: 0.15625rem 0;\n  min-width: 1rem;\n  width: 1.5rem;\n  background: ", ";\n"], ["\n  margin-bottom: 0.3125rem;\n  padding: 0.15625rem 0;\n  min-width: 1rem;\n  width: 1.5rem;\n  background: ", ";\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  line-height: 1.4;\n  margin-top: 0.3125rem;\n  margin-bottom: 0.3125rem;\n  color: ", ";\n  font-weight: 500;\n  text-decoration: none;\n"], ["\n  line-height: 1.4;\n  margin-top: 0.3125rem;\n  margin-bottom: 0.3125rem;\n  color: ", ";\n  font-weight: 500;\n  text-decoration: none;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  text-align: right;\n  line-height: 1.4;\n  margin-top: 0.3125rem;\n  margin-bottom: 0.3125rem;\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.75rem;\n  text-decoration: none;\n"], ["\n  text-align: right;\n  line-height: 1.4;\n  margin-top: 0.3125rem;\n  margin-bottom: 0.3125rem;\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.75rem;\n  text-decoration: none;\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  text-align: end;\n  line-height: 1.125rem;\n  color: ", ";\n  font-size: 0.75rem;\n  font-weight: 500;\n"], ["\n  text-align: end;\n  line-height: 1.125rem;\n  color: ", ";\n  font-size: 0.75rem;\n  font-weight: 500;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  text-align: right;\n  line-height: 1.125rem;\n  padding-bottom: 0.5rem;\n  color: ", ";\n  font-weight: 500;\n"], ["\n  text-align: right;\n  line-height: 1.125rem;\n  padding-bottom: 0.5rem;\n  color: ", ";\n  font-weight: 500;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  display: inline-grid;\n  padding-top: 2.8125rem;\n  padding-right: 0.5rem;\n\n  ", ";\n"], ["\n  display: inline-grid;\n  padding-top: 2.8125rem;\n  padding-right: 0.5rem;\n\n  ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n    width 9.375rem;\n    width: auto;\n    flex: 1;\n    padding-left: 3rem\n  "], ["\n    width 9.375rem;\n    width: auto;\n    flex: 1;\n    padding-left: 3rem\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _SignupForm = __webpack_require__("./src/components/SignupForm.js");
	
	var _SignupForm2 = _interopRequireDefault(_SignupForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Footer = _styledComponents2.default.div(_templateObject, (0, _utils.getThemeColor)("purpleDark"), function (props) {
	  return props.theme.media.mobile(_templateObject2);
	}, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	var Disclosure = _styledComponents2.default.div(_templateObject4);
	
	var FooterContent = _styledComponents2.default.div(_templateObject5);
	
	var NavigationLinks = _styledComponents2.default.div(_templateObject6);
	
	var Line = _styledComponents2.default.div(_templateObject7, (0, _utils.getThemeColor)("white"));
	
	var NavigationLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject8, (0, _utils.getThemeColor)("white"));
	
	var LegalLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject9, (0, _utils.getThemeColor)("grey"));
	
	var Copyright = _styledComponents2.default.div(_templateObject10, (0, _utils.getThemeColor)("grey"));
	
	var Address = _styledComponents2.default.div(_templateObject11, (0, _utils.getThemeColor)("white"));
	
	var SubscribeAndCopyright = _styledComponents2.default.div(_templateObject12, function (props) {
	  return props.theme.media.mobile(_templateObject13);
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    Footer,
	    null,
	    _react2.default.createElement(
	      FooterContent,
	      null,
	      _react2.default.createElement(
	        NavigationLinks,
	        null,
	        _react2.default.createElement(Line, null),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/trials" },
	          "Pipeline"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/mission" },
	          "Mission"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/team" },
	          "Team"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/news" },
	          "News"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/careers" },
	          "Careers"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/participate" },
	          "Participate"
	        ),
	        _react2.default.createElement(
	          NavigationLink,
	          { to: "/contact" },
	          "Contact"
	        )
	      ),
	      _react2.default.createElement(
	        SubscribeAndCopyright,
	        null,
	        _react2.default.createElement(_SignupForm2.default, null),
	        _react2.default.createElement(
	          Address,
	          null,
	          "818 E. Jefferson St. Suite 201, Charlottesville, VA 22902"
	        ),
	        _react2.default.createElement(
	          Copyright,
	          null,
	          "\xA9 ",
	          1900 + new Date().getYear(),
	          " Contraline, Inc. All Rights Reserved."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "right" } },
	          _react2.default.createElement(
	            LegalLink,
	            { to: "/privacy" },
	            "Privacy policy"
	          ),
	          _react2.default.createElement(
	            "span",
	            { style: { color: "#999", fontSize: "0.75rem", margin: "0 0.4rem" } },
	            "\xB7"
	          ),
	          _react2.default.createElement(
	            LegalLink,
	            { to: "/coi-policy" },
	            "FCOI policy"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Disclosure,
	      null,
	      "Contraline\u2019s products are investigational and have not been approved by the U.S. Food and Drug Administration (FDA) or any other regulatory authority."
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SignupForm.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding-bottom: 2.8125rem;\n\n  ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  padding-bottom: 2.8125rem;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 1.5625rem;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 1.5625rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    padding-bottom: 1.5625rem;\n  "], ["\n    padding-bottom: 1.5625rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-right: 0.9375rem;\n  border: 0;\n  outline: 0;\n  padding-left: 1rem;\n  padding-bottom: .25rem;\n  min-width: 12.375rem;\n  background-color: transparent;\n  border-bottom: 1px solid ", ";\n  -webkit-text-fill-color: ", ";\n  caret-color: ", ";\n  font-size: .75rem;\n  font-weight: 400;\n  border-radius: 0;\n\n  ", ";\n\n  ", ";\n"], ["\n  margin-right: 0.9375rem;\n  border: 0;\n  outline: 0;\n  padding-left: 1rem;\n  padding-bottom: .25rem;\n  min-width: 12.375rem;\n  background-color: transparent;\n  border-bottom: 1px solid ", ";\n  -webkit-text-fill-color: ", ";\n  caret-color: ", ";\n  font-size: .75rem;\n  font-weight: 400;\n  border-radius: 0;\n\n  ", ";\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    min-width: 9.375rem;\n  "], ["\n    min-width: 9.375rem;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    margin-bottom: .625rem;\n    min-width: 9.375rem;\n  "], ["\n    margin-bottom: .625rem;\n    min-width: 9.375rem;\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  height: 2rem;\n  min-width: 6.3125rem;\n  border-radius: 0;\n  border: 1px solid ", ";\n  background: ", ";\n  color: ", ";\n  font-size: .75rem;\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  height: 2rem;\n  min-width: 6.3125rem;\n  border-radius: 0;\n  border: 1px solid ", ";\n  background: ", ";\n  color: ", ";\n  font-size: .75rem;\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTimeout = __webpack_require__("./node_modules/react-timeout/src/web.js");
	
	var _reactTimeout2 = _interopRequireDefault(_reactTimeout);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _spinner = __webpack_require__("./assets/spinner.svg");
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _checkWhite = __webpack_require__("./assets/check-white.png");
	
	var _checkWhite2 = _interopRequireDefault(_checkWhite);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Subscribe = _styledComponents2.default.form(_templateObject, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	}, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	var EmailInput = _styledComponents2.default.input(_templateObject4, (0, _utils.getThemeColor)("white"), (0, _utils.getThemeColor)("white"), (0, _utils.getThemeColor)("white"), function (props) {
	  return props.theme.media.tablet(_templateObject5);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject6);
	});
	
	var Button = _styledComponents2.default.button(_templateObject7, (0, _utils.getThemeColor)("white"), (0, _utils.getThemeColor)("purpleDark"), (0, _utils.getThemeColor)("white"));
	
	var enhance = (0, _recompose.compose)(_reactTimeout2.default, (0, _recompose.withState)("email", "onEmailChange", ""), (0, _recompose.withState)("buttonState", "onButtonStateChange", ""), (0, _recompose.withHandlers)({
	  onEmailSubmit: function onEmailSubmit(_ref) {
	    var onButtonStateChange = _ref.onButtonStateChange,
	        setTimeout = _ref.setTimeout,
	        buttonState = _ref.buttonState,
	        onEmailChange = _ref.onEmailChange;
	    return function () {
	      onButtonStateChange("loading");
	      setTimeout(function () {
	        onButtonStateChange("success");
	      }, 1000);
	    };
	  }
	}));
	
	exports.default = enhance(function (_ref2) {
	  var email = _ref2.email,
	      onEmailChange = _ref2.onEmailChange,
	      buttonState = _ref2.buttonState,
	      onEmailSubmit = _ref2.onEmailSubmit;
	  return _react2.default.createElement(
	    Subscribe,
	    {
	      action: "https://contraline.us17.list-manage.com/subscribe/post",
	      method: "POST"
	    },
	    _react2.default.createElement("input", { type: "hidden", name: "u", value: "13cab056a773f8cbcff5f7549" }),
	    _react2.default.createElement("input", { type: "hidden", name: "id", value: "eddaefea6c" }),
	    _react2.default.createElement(EmailInput, {
	      type: "email",
	      placeholder: "Sign up for updates",
	      autocapitalize: "off",
	      autocorrect: "off",
	      name: "MERGE0",
	      id: "MERGE0",
	      size: "25",
	      value: email,
	      onChange: function onChange(e) {
	        return onEmailChange(e.target.value);
	      }
	    }),
	    _react2.default.createElement(
	      Button,
	      { onClick: onEmailSubmit },
	      buttonState === "loading" && _react2.default.createElement("img", { height: 12, src: _spinner2.default, style: { paddingRight: 8 } }),
	      buttonState === "success" && _react2.default.createElement("img", {
	        src: _checkWhite2.default,
	        style: {
	          height: 16,
	          display: "inline-block",
	          paddingRight: 8,
	          color: "white"
	        }
	      }),
	      buttonState === "success" ? "Subscribed" : "Subscribe"
	    )
	  );
	});
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/atoms/Sperm.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__("./src/styles/theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// First and Last path is repeated to allow smooth transitions
	var SpermTailPaths = ["M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
	  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
	  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5", "M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 \
	  19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,\
	  47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1", "M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,\
	  33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,\
	  46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4", "M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 \
	  24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,\
	  41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9", "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
	  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
	  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"];
	
	exports.default = function (_ref) {
	  var _ref$animated = _ref.animated,
	      animated = _ref$animated === undefined ? true : _ref$animated,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? "white" : _ref$color;
	
	  var animation = _react2.default.createElement("animate", {
	    dur: "0.6s",
	    repeatCount: "indefinite",
	    attributeName: "d",
	    values: SpermTailPaths.join(";")
	  });
	
	  var SpermTail = _react2.default.createElement(
	    "path",
	    {
	      d: SpermTailPaths[0],
	      stroke: _theme2.default.colors[color],
	      strokeWidth: "3",
	      strokeLinecap: "round"
	    },
	    animated && animation
	  );
	
	  var SpermHead = _react2.default.createElement("ellipse", {
	    fill: _theme2.default.colors[color],
	    transform: "translate(40.501453, 14.237608) rotate(45) translate(-40.501453, -14.237608) ",
	    cx: "40.501453",
	    cy: "14.2376084",
	    rx: "8",
	    ry: "11.8646142"
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: "sperm" },
	    _react2.default.createElement(
	      "svg",
	      {
	        width: "80px",
	        height: "25px",
	        viewBox: "0 0 80 25",
	        version: "1.1",
	        xmlns: "http://www.w3.org/2000/svg"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", transform: "translate(37, -30) rotate(45)" },
	        SpermHead,
	        SpermTail
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/blocks/LoadingScreen.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  opacity: ", ";\n  background: ", ";\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 9;\n  transition: opacity 500ms, bottom 1000ms, top 1000ms;\n"], ["\n  display: ", ";\n  opacity: ", ";\n  background: ", ";\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 9;\n  transition: opacity 500ms, bottom 1000ms, top 1000ms;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Logo = __webpack_require__("./src/components/Logo.js");
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _Sperm = __webpack_require__("./src/components/atoms/Sperm.js");
	
	var _Sperm2 = _interopRequireDefault(_Sperm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Screen = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var loading = _ref.loading;
	  return loading ? "flex" : "none";
	}, function (_ref2) {
	  var loading = _ref2.loading;
	  return loading ? 1 : 0;
	}, (0, _utils.getThemeColor)("purpleDark"));
	
	exports.default = function (_ref3) {
	  var loading = _ref3.loading;
	  return _react2.default.createElement(
	    Screen,
	    { loading: loading },
	    _react2.default.createElement(_Sperm2.default, { color: "teal" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Footer = __webpack_require__("./src/components/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _LoadingScreen = __webpack_require__("./src/components/blocks/LoadingScreen.js");
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _theme = __webpack_require__("./src/styles/theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	__webpack_require__("./src/styles/main.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_LOADED = "PAGE_LOADED";
	var FIRE_WHEN_READY = "FIRE_WHEN_READY";
	
	var enhance = (0, _recompose.compose)((0, _recompose.withState)("loadingTarget", "onLoadingTargetChange", false), (0, _recompose.lifecycle)({
	  componentWillMount: function componentWillMount() {
	    if (typeof document !== "undefined") __webpack_require__("./src/rollbar.js");
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var loadingTarget = nextProps.loadingTarget,
	        onLoadingTargetChange = nextProps.onLoadingTargetChange;
	
	
	    if (nextProps.location.pathname !== this.props.location.pathname && !loadingTarget) {
	      debugger;
	      onLoadingTargetChange(nextProps.location.pathname);
	      window.scrollTo(0, 0);
	      setTimeout(function () {
	        if (loadingTarget === FIRE_WHEN_READY) onLoadingTargetChange(null);else onLoadingTargetChange(PAGE_LOADED);
	      }, 750);
	    }
	
	    if (nextProps.location.pathname === this.props.location.pathname && loadingTarget && (loadingTarget === PAGE_LOADED || loadingTarget !== FIRE_WHEN_READY)) {
	      if (loadingTarget === PAGE_LOADED) {
	        onLoadingTargetChange(null);
	      } else {
	        onLoadingTargetChange(FIRE_WHEN_READY);
	      }
	    }
	  }
	}));
	
	var Template = function Template(_ref) {
	  var _ref$loadingTarget = _ref.loadingTarget,
	      loadingTarget = _ref$loadingTarget === undefined ? "/" : _ref$loadingTarget,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _theme2.default },
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          minHeight: "100vh",
	          display: "flex",
	          flexDirection: "column"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { style: { flex: 1, display: "flex", flexDirection: "column" } },
	        children()
	      ),
	      _react2.default.createElement(_Footer2.default, null),
	      _react2.default.createElement(_LoadingScreen2.default, { loading: !!loadingTarget })
	    )
	  );
	};
	
	exports.default = enhance(Template);
	module.exports = exports["default"];

/***/ }),

/***/ "./src/rollbar.js":
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _rollbarConfig = {
	  accessToken: "fbe2c48e1cb0446e9666cc8cdf756a9f",
	  captureUncaught: true,
	  captureUnhandledRejections: true,
	  payload: {
	    environment: "production"
	  }
	};
	// Rollbar Snippet
	!function (r) {
	  function o(e) {
	    if (n[e]) return n[e].exports;
	    var t = n[e] = { exports: {}, id: e, loaded: !1 };
	    return r[e].call(t.exports, t, t.exports, o), t.loaded = !0, t.exports;
	  }
	  var n = {};
	  return o.m = r, o.c = n, o.p = "", o(0);
	}([function (r, o, n) {
	  var e = n(1),
	      t = n(4);
	  _rollbarConfig = _rollbarConfig || {}, _rollbarConfig.rollbarJsUrl = _rollbarConfig.rollbarJsUrl || "https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.1.0/rollbar.min.js", _rollbarConfig.async = void 0 === _rollbarConfig.async || _rollbarConfig.async;
	  var a = e.setupShim(window, _rollbarConfig),
	      l = t(_rollbarConfig);
	  window.rollbar = e.Rollbar, a.loadFull(window, document, !_rollbarConfig.async, _rollbarConfig, l);
	}, function (r, o, n) {
	  function e(r) {
	    return function () {
	      try {
	        return r.apply(this, arguments);
	      } catch (r) {
	        try {
	          console.error("[Rollbar]: Internal error", r);
	        } catch (r) {}
	      }
	    };
	  }
	  function t(r, o) {
	    this.options = r, this._rollbarOldOnError = null;
	    var n = s++;
	    this.shimId = function () {
	      return n;
	    }, window && window._rollbarShims && (window._rollbarShims[n] = { handler: o, messages: [] });
	  }
	  function a(r, o) {
	    var n = o.globalAlias || "Rollbar";
	    if ("object" === _typeof(r[n])) return r[n];
	    r._rollbarShims = {}, r._rollbarWrappedError = null;
	    var t = new d(o);
	    return e(function () {
	      return o.captureUncaught && (t._rollbarOldOnError = r.onerror, i.captureUncaughtExceptions(r, t, !0), i.wrapGlobals(r, t, !0)), o.captureUnhandledRejections && i.captureUnhandledRejections(r, t, !0), r[n] = t, t;
	    })();
	  }
	  function l(r) {
	    return e(function () {
	      var o = this,
	          n = Array.prototype.slice.call(arguments, 0),
	          e = { shim: o, method: r, args: n, ts: new Date() };
	      window._rollbarShims[this.shimId()].messages.push(e);
	    });
	  }
	  var i = n(2),
	      s = 0,
	      c = n(3),
	      p = function p(r, o) {
	    return new t(r, o);
	  },
	      d = c.bind(null, p);
	  t.prototype.loadFull = function (r, o, n, t, a) {
	    var l = function l() {
	      var o;
	      if (void 0 === r._rollbarDidLoad) {
	        o = new Error("rollbar.js did not load");
	        for (var n, e, t, l, i = 0; n = r._rollbarShims[i++];) {
	          for (n = n.messages || []; e = n.shift();) {
	            for (t = e.args || [], i = 0; i < t.length; ++i) {
	              if (l = t[i], "function" === typeof l) {
	                l(o);
	                break;
	              }
	            }
	          }
	        }
	      }
	      "function" === typeof a && a(o);
	    },
	        i = !1,
	        s = o.createElement("script"),
	        c = o.getElementsByTagName("script")[0],
	        p = c.parentNode;
	    s.crossOrigin = "", s.src = t.rollbarJsUrl, n || (s.async = !0), s.onload = s.onreadystatechange = e(function () {
	      if (!(i || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState)) {
	        s.onload = s.onreadystatechange = null;
	        try {
	          p.removeChild(s);
	        } catch (r) {}
	        i = !0, l();
	      }
	    }), p.insertBefore(s, c);
	  }, t.prototype.wrap = function (r, o) {
	    try {
	      var n;
	      if (n = "function" === typeof o ? o : function () {
	        return o || {};
	      }, "function" !== typeof r) return r;
	      if (r._isWrap) return r;
	      if (!r._wrapped && (r._wrapped = function () {
	        try {
	          return r.apply(this, arguments);
	        } catch (e) {
	          var o = e;
	          throw "string" === typeof o && (o = new String(o)), o._rollbarContext = n() || {}, o._rollbarContext._wrappedSource = r.toString(), window._rollbarWrappedError = o, o;
	        }
	      }, r._wrapped._isWrap = !0, r.hasOwnProperty)) for (var e in r) {
	        r.hasOwnProperty(e) && (r._wrapped[e] = r[e]);
	      }return r._wrapped;
	    } catch (o) {
	      return r;
	    }
	  };
	  for (var u = "log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection".split(","), f = 0; f < u.length; ++f) {
	    t.prototype[u[f]] = l(u[f]);
	  }r.exports = { setupShim: a, Rollbar: d };
	}, function (r, o) {
	  function n(r, o, n) {
	    if (r) {
	      var t;
	      "function" === typeof o._rollbarOldOnError ? t = o._rollbarOldOnError : r.onerror && !r.onerror.belongsToShim && (t = r.onerror, o._rollbarOldOnError = t);
	      var a = function a() {
	        var n = Array.prototype.slice.call(arguments, 0);
	        e(r, o, t, n);
	      };
	      a.belongsToShim = n, r.onerror = a;
	    }
	  }
	  function e(r, o, n, e) {
	    r._rollbarWrappedError && (e[4] || (e[4] = r._rollbarWrappedError), e[5] || (e[5] = r._rollbarWrappedError._rollbarContext), r._rollbarWrappedError = null), o.handleUncaughtException.apply(o, e), n && n.apply(r, e);
	  }
	  function t(r, o, n) {
	    if (r) {
	      "function" === typeof r._rollbarURH && r._rollbarURH.belongsToShim && r.removeEventListener("unhandledrejection", r._rollbarURH);
	      var e = function e(r) {
	        var n = r.reason,
	            e = r.promise,
	            t = r.detail;
	        !n && t && (n = t.reason, e = t.promise), o && o.handleUnhandledRejection && o.handleUnhandledRejection(n, e);
	      };
	      e.belongsToShim = n, r._rollbarURH = e, r.addEventListener("unhandledrejection", e);
	    }
	  }
	  function a(r, o, n) {
	    if (r) {
	      var e,
	          t,
	          a = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
	      for (e = 0; e < a.length; ++e) {
	        t = a[e], r[t] && r[t].prototype && l(o, r[t].prototype, n);
	      }
	    }
	  }
	  function l(r, o, n) {
	    if (o.hasOwnProperty && o.hasOwnProperty("addEventListener")) {
	      for (var e = o.addEventListener; e._rollbarOldAdd && e.belongsToShim;) {
	        e = e._rollbarOldAdd;
	      }var t = function t(o, n, _t) {
	        e.call(this, o, r.wrap(n), _t);
	      };
	      t._rollbarOldAdd = e, t.belongsToShim = n, o.addEventListener = t;
	      for (var a = o.removeEventListener; a._rollbarOldRemove && a.belongsToShim;) {
	        a = a._rollbarOldRemove;
	      }var l = function l(r, o, n) {
	        a.call(this, r, o && o._wrapped || o, n);
	      };
	      l._rollbarOldRemove = a, l.belongsToShim = n, o.removeEventListener = l;
	    }
	  }
	  r.exports = {
	    captureUncaughtExceptions: n,
	    captureUnhandledRejections: t,
	    wrapGlobals: a
	  };
	}, function (r, o) {
	  function n(r, o) {
	    this.impl = r(o, this), this.options = o, e(n.prototype);
	  }
	  function e(r) {
	    for (var o = function o(r) {
	      return function () {
	        var o = Array.prototype.slice.call(arguments, 0);
	        if (this.impl[r]) return this.impl[r].apply(this.impl, o);
	      };
	    }, n = "log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,_createItem,wrap,loadFull,shimId".split(","), e = 0; e < n.length; e++) {
	      r[n[e]] = o(n[e]);
	    }
	  }
	  n.prototype._swapAndProcessMessages = function (r, o) {
	    this.impl = r(this.options);
	    for (var n, e, t; n = o.shift();) {
	      e = n.method, t = n.args, this[e] && "function" === typeof this[e] && this[e].apply(this, t);
	    }return this;
	  }, r.exports = n;
	}, function (r, o) {
	  r.exports = function (r) {
	    return function (o) {
	      if (!o && !window._rollbarInitialized) {
	        r = r || {};
	        for (var n, e, t = r.globalAlias || "Rollbar", a = window.rollbar, l = function l(r) {
	          return new a(r);
	        }, i = 0; n = window._rollbarShims[i++];) {
	          e || (e = n.handler), n.handler._swapAndProcessMessages(l, n.messages);
	        }window[t] = e, window._rollbarInitialized = !0;
	      }
	    };
	  };
	}]);
	// End Rollbar Snippet

/***/ }),

/***/ "./src/styles/main.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/styles/theme.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "]);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = {
	  colors: {
	    red: "red",
	    salmon: "#de4b4b",
	    blue: "#4A90E2",
	    blueDark: "#005baa",
	    herrBlue: "#4363a0",
	    purpleDark: "#061e28",
	    green: "green",
	    teal: "#43bcba",
	    black: "#000000",
	    white: "#FFFFFF",
	    greyLight: "#f3f3f3",
	    greyAccent: "#d3d3d3",
	    halfGrey: "linear-gradient(to bottom, transparent 50%, #f3f3f3 50%)",
	    greyDient: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    greyDientReverse: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    grey: "#c3c3c3",
	    greyDark: "#979797",
	    greyTimeline: "#4A4A4A",
	    dark: "#000914",
	    transparent: "rgba(0, 0, 0, 0)"
	  },
	  media: {
	    mobile: function mobile() {
	      return (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, arguments));
	    },
	    tablet: function tablet() {
	      return (0, _styledComponents.css)(_templateObject2, _styledComponents.css.apply(undefined, arguments));
	    },
	    desktop: function desktop() {
	      return (0, _styledComponents.css)(_templateObject3, _styledComponents.css.apply(undefined, arguments));
	    },
	    card: function card() {
	      return (0, _styledComponents.css)(_templateObject4, _styledComponents.css.apply(undefined, arguments));
	    }
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c033d9df73f91a41518c.js